module.exports = __webpack_public_path__ + "img/notification.8cbb3014.svg";